import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { WorkOrder } from '@app/dashboard/work-order.model';
import { OfflineDataDb } from '@app/core/db/offline-data';
import { AppService } from '@app/core/services/app.service';
import { WorkOrderDetailsService } from '@app/work-order/work-order-details.service';
import { WorkOrderService } from '@app/dashboard/work-order.service';

@Component({
  selector: 'app-offline-dashboard',
  templateUrl: './offline-dashboard.component.html',
  styleUrls: ['./offline-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OfflineDashboardComponent implements OnInit, OnDestroy {
  private workOrders: WorkOrder[] = [];

  constructor(
    private offlineData: OfflineDataDb,
    private appService: AppService,
    private workOrderDetailsService: WorkOrderDetailsService,
    private workOrderService: WorkOrderService,
  ) {}

  async ngOnInit() {
    await this.workOrderService.load();
    this.workOrders = this.workOrderService.get();
  }

  ngOnDestroy() {
    this.workOrderService.unload();
  }

  toggleFavourite() {
    this.workOrders = this.workOrderService.get();
  }

  getWorkOrders(): WorkOrder[] {
    return this.workOrders;
  }

  removeWorkOrder(workOrder: WorkOrder) {
    this.workOrders = this.workOrders.filter((wo) => wo.id !== workOrder.id);
  }
}
